<template>
  <div class="createOrEditRoot">
    <div class="resourceFormPage divContainer collectionModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />
      <div v-else class="resourceFormPage__layout">
        <el-form
          ref="ruleForm"
          label-position="top"
          size="small"
          class="resourceFormPage__form"
          :model="ruleForm"
          :rules="rules"
          hide-required-asterisk
          @submit.native.prevent
        >
          <div class="resourceFormPage__headerDock">
            <header class="resourceFormPage__actionBar">
              <div class="resourceFormPage__lead">
                <h1 class="resourceFormPage__pageTitle">
                  {{ isCreate ? '创建数据集' : '编辑数据集' }}
                </h1>
              </div>
              <div class="resourceFormPage__actions">
                <button
                  v-if="!isCreate"
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--ghost"
                  @click="goBack"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--primary"
                  :disabled="buttonLoading"
                  @click="submitForm"
                >
                  {{ buttonLoading ? '保存中…' : '保存' }}
                </button>
              </div>
            </header>
          </div>

          <main class="resourceFormPage__main main dataFormPage__main">
            <data-form-shell
              :rule-form="ruleForm"
              :relation-list.sync="relationList"
              :app-options="appOptions"
              :is-create="isCreate"
              @relation-app-change="loadRelationTemplate"
            />
          </main>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  dataCreate,
  dataEdit,
  getaAllRelationApp,
  getDataById,
  getDataRelation,
} from '../../../api/dataManage'
import DataFormShell from './DataFormShell.vue'
import {
  DATA_FORM_RULES,
  createEmptyDataRuleForm,
  mapDataDetailToForm,
  parseDataRelationList,
  validateDataRelationList,
} from './dataFormConstants'

export default {
  name: 'DataCreateOrEdit',
  components: {
    DataFormShell,
  },
  data() {
    return {
      isCreate: true,
      loading: false,
      buttonLoading: false,
      ruleForm: createEmptyDataRuleForm(),
      relationList: [],
      appOptions: [],
      rules: DATA_FORM_RULES,
    }
  },
  created() {
    this.isCreate = this.$route.path.indexOf('edit') === -1
    this.loadAppOptions()
    if (!this.isCreate) {
      this.loadDataDetail()
    }
  },
  methods: {
    loadAppOptions() {
      getaAllRelationApp().then((res) => {
        if (res.success) {
          this.appOptions = res.data || []
        }
      })
    },
    loadDataDetail() {
      this.loading = true
      getDataById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            this.ruleForm = mapDataDetailToForm(res.data)
            this.relationList = parseDataRelationList(res.data.dataRelation)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadRelationTemplate(appId) {
      if (!appId) {
        this.relationList = []
        return
      }
      getDataRelation({ id: appId }).then((res) => {
        if (res.success) {
          this.relationList = parseDataRelationList(res.data)
        }
      })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message.info('请完整填写表单')
          return
        }

        const relationCheck = validateDataRelationList(this.relationList)
        if (!relationCheck.valid) {
          this.$message.error(relationCheck.message)
          return
        }

        this.buttonLoading = true
        const request = this.isCreate
          ? dataCreate(this.ruleForm, this.relationList)
          : dataEdit(this.ruleForm, this.relationList, this.$route.params.id)

        request
          .then((res) => {
            if (res.success) {
              this.$message.success(this.isCreate ? '创建成功' : '保存成功')
              this.$router.push('/channel/data/list')
            }
          })
          .finally(() => {
            this.buttonLoading = false
          })
      })
    },
    goBack() {
      this.$router.push('/channel/data/list')
    },
  },
}
</script>

<style scoped>
.createOrEditRoot,
.fullContainer {
  height: 100%;
}

.resourceFormPage__form {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>

<style>
.collectionModule.divContainer {
  min-height: 100%;
  background: var(--link-canvas);
}

.collectionModule .main {
  background: transparent;
}
</style>
